import React, { FormEvent } from 'react';
import { Dropdown, IDropdownOption } from '@fluentui/react';

import styles from './CustomTimePicker.module.scss';
import { pad } from '../../utils';

const hours = Array.from({ length: 24 }, (_, i) => ({ key: i, text: pad(i, 2) }));
const minutes = Array.from({ length: 60 }, (_, i) => ({ key: i, text: pad(i, 2) }));

type Props = {
	value: { h: number; m: number };
	onChange: (value: { h: number; m: number }) => void;
};

export const CustomTimePicker = ({ onChange, value }: Props) => {
	const changeMinutes = (_: FormEvent<HTMLDivElement>, item?: IDropdownOption) => {
		if (!item) return;
		onChange({ h: value.h, m: +item.key });
	};

	const changeHours = (_: FormEvent<HTMLDivElement>, item?: IDropdownOption) => {
		if (!item) return;
		onChange({ h: +item.key, m: value.m });
	};

	return (
		<div className={styles.content}>
			<Dropdown options={hours} selectedKey={value.h} onChange={changeHours} />
			<Dropdown options={minutes} selectedKey={value.m} onChange={changeMinutes} />
		</div>
	);
};
